import {
  answerAwardAmount,
  answerExclusive,
  answerImage,
  answerIsCorrect,
  answerLogicRules,
  answerOther,
  createAnswerSchemaWithMixins,
} from '../answerSchemaFields';
import {
  createQuestionSchemaWithMixins,
  questionAppearanceAnswerImage,
  questionAutoNext,
  questionHasAnswerCountLimit,
  questionHasAnswersLimit,
  questionHasAwardMultiple,
  questionHasCorrectAnswer,
  questionHasHints,
  questionHasOthers,
  questionHasTimer,
  questionHideNotSelectedAnswers,
  questionImagesAspectRatio,
  questionInstantStatistic,
  questionRandomizeAnswers,
  questionRequiresAnswer,
  questionSkipIfOnlySystemAnswers,
} from '../questionSchemaFields';
import { config } from './MultipleFromPicturePoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionAutoNext,
    questionHasAnswerCountLimit,
    questionHasAwardMultiple,
    questionHasCorrectAnswer,
    questionHasHints,
    questionHasTimer,
    questionHasOthers,
    questionHideNotSelectedAnswers,
    questionHasAnswersLimit,
    questionImagesAspectRatio,
    questionRandomizeAnswers,
    questionRequiresAnswer,
    questionSkipIfOnlySystemAnswers,
    questionInstantStatistic,
    questionAppearanceAnswerImage,
  },
  type: config.name,
  answer: createAnswerSchemaWithMixins({
    mixins: {
      answerAwardAmount,
      answerImage,
      answerIsCorrect,
      answerLogicRules,
      answerExclusive,
      answerOther,
    },
  }),
});
